import type { ReactNode } from "react";
import { cn } from "../utils/cn";

interface CardProps {
  children: ReactNode;
  className?: string;
  id?: string;
  gradient?: boolean;
}

export const Card = ({
  children,
  className = "",
  id,
  gradient = false,
}: CardProps) => {
  return (
    <div className={cn("card", gradient && "card-gradient", className)} id={id}>
      {children}
    </div>
  );
};
